export const ORGANIZATION_ROUTE_NAME = 'perimeters'
export const ORGANIZATION_FILTERED_ROUTE_NAME = 'filtered_perimeter'
